import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { base } from '@/base/base'
import { WebDefine } from '@/defines/WebDefine'
import { log } from '@/utils/functions'
import { PopupViews } from '@/defines/EnumDefine'

export class VipModule extends ModuleBase {
  private getedVipInfos_ = false
  private vipInfos: any = null
  private buyed_ = false
  private rewardsCount_ = 0
  private paying: any = {}

  init(): void {
    this.getedVipInfos_ = false
    this.vipInfos = null
    this.buyed_ = false
    this.rewardsCount_ = 0
    this.paying = {}
  }

  onClear(): void {
    this.getedVipInfos_ = false
    this.vipInfos = null
    this.buyed_ = false
    this.rewardsCount_ = 0
    this.paying = {}
  }

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {}

  onPreloadData(): void {
    log('VipModule onPreloadData')
    this.requestVipInfos()
  }

  requestVipInfos(): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    //  获取客服邮箱和 tg
    base.httpUtil
      .postJson(WebDefine.userVipInfo, data)
      .then((respJson: any) => {
        if (respJson && respJson.code == 200) {
          this.getedVipInfos_ = true
          this.vipInfos = respJson.data.list
          if (this.vipInfos) {
            this.vipInfos.sort((a: any, b: any) => a.vip_card_id - b.vip_card_id)
          }
          this.buyed_ = false
          let buyedCardType = 0
          this.rewardsCount_ = 0
          if (this.vipInfos) {
            for (let i = 0; i < this.vipInfos.length; i++) {
              if (this.vipInfos[i].buy_status == 0) {
                this.paying[this.vipInfos[i].type] = false
                buyedCardType = this.vipInfos[i].type
                this.buyed_ = true
                this.rewardsCount_ = this.rewardsCount_ + 1
              }
            }
          }
          // hall.eventDispatcher.emit(hall.EventDefine.TryAddPopupView, hall.Constants.VipInfos);
          hall.eventDispatcher.emit(hall.EventDefine.GetVipInfo, 'success')

          if (this.buyed_) {
            hall.eventDispatcher.emit(hall.EventDefine.BuyedVip, buyedCardType)
          }
        } else {
          hall.eventDispatcher.emit(
            hall.EventDefine.GetVipInfo,
            'fail',
            respJson ? respJson.msg : '',
            respJson && respJson.res ? respJson.res.code : 0,
          )
        }
      })
      .catch((error: any) => {
        log('error:', error)
        hall.eventDispatcher.emit(hall.EventDefine.GetVipInfo, 'fail', '', error)
      })
  }

  getVipInfos() {
    return this.vipInfos
  }

  getCardInfo(cardType: any) {
    if (this.vipInfos == null) {
      return null
    }
    for (let i = 0; i < this.vipInfos.length; i++) {
      if (this.vipInfos[i].type == cardType) {
        return this.vipInfos[i]
      }
    }
  }

  isGetedVipInfos() {
    return this.getedVipInfos_
  }

  isBuyedVip() {
    if (this.getedVipInfos_) {
      return this.buyed_
    }
    return false
  }

  //获取VIP卡最高的折扣百分比
  getVipMaxDiscount() {
    if (this.vipInfos == null) {
      return 0
    }
    let discountMax = 0
    for (let i = 0; i < this.vipInfos.length; i++) {
      const info = this.vipInfos[i]
      const amount =
        info.buy_pay +
        info.buy_bonus +
        info.buy_diamond +
        (info.recv_bonus + info.recv_diamond) * info.day
      const discount = Math.ceil((amount / info.money) * 100)
      if (discount > discountMax) {
        discountMax = discount
      }
    }
    return discountMax / 100
  }

  onVipShow() {
    //判断是否已经充值过vip了
    const vipInfo = this.getVipInfos()
    const dailyCashInfo = hall.vipDailyCashModule.getDailyCashInfos()
    //vip信息和每日奖励都会刷新这个函数
    const dailyCashOver = hall.vipDailyCashModule.getVipDailyOver() //是否领取完每日奖励
    if (vipInfo != null) {
      //有vip的数据，判断当前是否购买了vip
      const buyedVip = this.isBuyedVip()
      if (buyedVip) {
        base.uiHudSystem.show('VipRewardPanel')
      } else {
        //self.Panel_vip_remind_dot:setVisible(this.getRewardsCount() > 0)
        base.uiHudSystem.show('VipCardPanel')
      }
    } else if (dailyCashInfo != null && dailyCashOver == false) {
      //vip没下发数据，但是每日礼包有下发
      //默认已经购买了vip
      base.uiHudSystem.show('VipRewardPanel')
    } else {
      //俩数据都没有（俩icon都不显示）
      base.toast(hall.Language.Vip_ERROR)
    }
  }

  // 是否已获取到弹窗判断的数据
  isGetedPopupData() {
    return this.getedVipInfos_
  }

  // 是否需要弹窗
  popupView() {
    // VIP卡购买弹框——每次返回大厅都弹， 完成首充，未购买
    //并且完成了新人礼包
    const goodsInfos = hall.addCashModule.getGoodsInfos()
    const welcomeEnd = hall.welcomeGiftModule.isWelcomeEnd()
    if (
      goodsInfos &&
      !goodsInfos.first_pay &&
      welcomeEnd &&
      hall.welcomeGiftModule.welocmeInfo_ != null
    ) {
      const buyed = hall.vipModule.isBuyedVip()
      if (!buyed) {
        hall.popupViewModule.addPopupView(PopupViews.VipCardPanel)
      }
    }
  }
}
